/* eslint-disable @typescript-eslint/no-explicit-any */
import {Vue, Component, Watch} from "vue-property-decorator";
// import { login } from "@/plugins/api";
import {UserModule} from "@/store/modules/user";
import {
    getCode, loginCheckCode, getMyselfUser,
    getUserList, checkApplyLogin, getQrcode, checkQrcode
} from '@/api/common'
import {RouterModule} from "@/store/modules/router";
import QRCode from 'qrcodejs2';

@Component({})
export default class Login extends Vue {
    private phone: any = "";
    private code = "";
    private timeNum = null
    private accountPasswordLogin = true
    private qrCodeImg = ''
    private timer = null
    private QRStatus = ''

    created() {

        if (this.$route.query.phone) {
            const phone: any = this.$route.query.phone ? this.$route.query.phone : ''
            window.localStorage.setItem("phone", phone);
        }
        this.phone = window.localStorage.getItem("phone") ? window.localStorage.getItem("phone") : ''
        if (this.accountPasswordLogin == false) {
            //  获取二维码识别号
            this.getQrcode();
        }
    }

    mounted() {
      // this.checkQrcode();
      //   if ((this.accountPasswordLogin == false) && ( this.QRStatus == '2' || this.QRStatus !== '3') ) {
      //     this.timer = window.setInterval(() => {
      //       setTimeout(() => {
      //         this.checkQrcode()
      //       }, 0)
      //     }, 2000)
      //   }
    }

    useScan() {
        if ((this.accountPasswordLogin == false) && (this.QRStatus !== '2' && this.QRStatus !== '3')) {
            this.checkQrcode();
            window.clearInterval(this.timer);
            this.timer = window.setInterval(() => {
                setTimeout(() => {
                    if (this.accountPasswordLogin == false) {
                        if (this.QRStatus == '2' || this.QRStatus == '3') {
                            // window.clearInterval(this.timer)
                        } else {
                            this.checkQrcode()
                        }
                    }
                }, 0)
            }, 2000)
        }

    }

    async getQrcode() {
        const data: any = await getQrcode()
        this.qrCodeImg = data.qrcode
        this.$nextTick(() => {
            this.creatQrCode(); // 创建二维码
        })
    }

    handleRefresh() {
        this.qrCodeImg = ''
        this.QRStatus = ''
        this.getQrcode();
    }

    handleChangeStep() {
        this.accountPasswordLogin = !this.accountPasswordLogin
        if (this.accountPasswordLogin === false) {
          //  获取二维码识别号
          this.getQrcode();
        }

    }

    // 轮询
    async checkQrcode() {
        const data = await checkQrcode(this.qrCodeImg);
        this.QRStatus = data.status.toString()
        if (this.QRStatus == '2') {
            setTimeout(function () {
                window.location.href = window.location.origin + '/message/remind'
                this.$message.success('登录成功')
                window.localStorage.clear();
                this.getUserInfo();
                this.initRouter();
                this.getUserList();
            }, 1000); // 定时时间

        }
    }

    /* 创建二维码 */
    creatQrCode() {
        new QRCode(this.$refs.qrCodeUrl, {
            text:JSON.stringify({
                qrCode: this.qrCodeImg,
                id: 12345678
            }), // 二维码的内容
            width: 120,
            height: 120,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
        });
        this.useScan();
    }


    private async login() {
        if (!this.phone) {
            this.$message.error('手机号不可为空')
            return
        }
        if (!this.code) {
            this.$message.error('短信验证码不可为空')
            return
        }
        await loginCheckCode({
            phone: this.phone,
            code: this.code
        })
        window.location.href = window.location.origin + '/message/remind'
        this.$message.success('登录成功')
        window.localStorage.clear()
        this.getUserInfo();
        this.initRouter();
        this.getUserList();
    }

    async getUserInfo() {
        const data: any = await getMyselfUser();
        UserModule.SET_USER_INFO(data);
    }

    async getUserList() {
        const data: any = await getUserList();
        UserModule.SET_USER_LIST(data);
    }

    initRouter() {
        RouterModule.initRouter1();
    }

    private async getCode() {
        this.code = null
        if (!this.phone) {
            this.$message.error('手机号不可为空')
            return
        }
        const data: any = await getCode(this.phone)
        if (data.result) {
            this.timeNum = 60;
            const set = setInterval(() => {
                this.timeNum = --this.timeNum;
            }, 1000);
            setTimeout(() => {
                this.timeNum = null;
                clearInterval(set);
            }, 60000);
        }
    }

    async applyOfStudent() {
        await checkApplyLogin();
        //  跳转详情
        window.open(window.location.origin + '/customerInfo', '_blank')

    }

    handleCancelEmpower() {
        this.qrCodeImg = ''
        this.QRStatus = ''
        this.getQrcode()
    }

    beforeDestroy() {
        if (this.timer) {
            window.clearInterval(this.timer)
        }
    }
}
